/* Alchemy - background music player ("Beneath the Canopy", by Alchemy).
   Off by default; a small golden button starts/stops it. Gentle volume, fades in and out,
   and continues where it left off when the visitor moves to another page. */
(function () {
  if (window.__alcMusic) return;
  window.__alcMusic = true;

  var SRC = 'https://cdn.shopify.com/s/files/1/0915/3996/4268/files/beneath_the_canopy.mp3';
  var VOLUME = 0.25;           /* soft background level */
  var KEY = 'alcAmbience', POS = 'alcMusicPos';
  var lang = (document.documentElement.lang || 'fr').slice(0, 2);
  var L = lang === 'en'
    ? { on: 'Play the music', off: 'Pause the music' }
    : { on: 'Lancer la musique', off: 'Couper la musique' };

  var audio = new Audio();
  audio.src = SRC;
  audio.loop = true;
  audio.preload = 'none';
  audio.volume = 0;
  var running = false, fadeTimer = null;

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'alc-sound';
  btn.setAttribute('aria-pressed', 'false');
  btn.setAttribute('aria-label', L.on);
  btn.title = L.on;
  btn.innerHTML =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18V6l10-2v12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="6.5" cy="18" r="2.5" fill="currentColor"/><circle cx="16.5" cy="16" r="2.5" fill="currentColor"/></svg>' +
    '<span class="alc-sound__bars" aria-hidden="true"><i></i><i></i><i></i></span>';
  document.body.appendChild(btn);

  var css = document.createElement('style');
  css.textContent =
    '.alc-sound{position:fixed;left:18px;bottom:18px;z-index:50;width:48px;height:48px;border-radius:50%;' +
    'border:1px solid #fff3c4;cursor:pointer;display:grid;place-items:center;padding:0;color:#2b1d10;' +
    'background:linear-gradient(135deg,#8a6420,#d4af37 45%,#fff0b8 60%,#c99a2e);' +
    'box-shadow:0 0 14px rgba(212,175,55,.45),0 2px 6px rgba(0,0,0,.6);transition:transform .2s,box-shadow .2s}' +
    '.alc-sound:hover{transform:scale(1.08);box-shadow:0 0 22px rgba(212,175,55,.7),0 2px 6px rgba(0,0,0,.6)}' +
    '.alc-sound:focus-visible{outline:2px solid #fff3c4;outline-offset:3px}' +
    '.alc-sound svg{width:22px;height:22px}' +
    '.alc-sound__bars{display:none;gap:3px;align-items:flex-end;height:18px}' +
    '.alc-sound__bars i{display:block;width:3px;background:#2b1d10;border-radius:2px;animation:alcBar 1.4s ease-in-out infinite}' +
    '.alc-sound__bars i:nth-child(2){animation-delay:.3s}.alc-sound__bars i:nth-child(3){animation-delay:.6s}' +
    '.alc-sound.is-on svg{display:none}.alc-sound.is-on .alc-sound__bars{display:flex}' +
    '@keyframes alcBar{0%,100%{height:5px}50%{height:17px}}' +
    '@media (prefers-reduced-motion:reduce){.alc-sound__bars i{animation:none;height:10px}}' +
    '@media (max-width:749px){.alc-sound{width:42px;height:42px;left:12px;bottom:12px}}';
  document.head.appendChild(css);

  function fadeTo(target, ms, done) {
    clearInterval(fadeTimer);
    var startV = audio.volume, t0 = Date.now();
    fadeTimer = setInterval(function () {
      var k = Math.min(1, (Date.now() - t0) / ms);
      audio.volume = Math.max(0, Math.min(1, startV + (target - startV) * k));
      if (k >= 1) { clearInterval(fadeTimer); if (done) done(); }
    }, 50);
  }
  function setUI(on) {
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? L.off : L.on);
    btn.title = on ? L.off : L.on;
  }

  function start() {
    running = true;
    setUI(true);
    try {
      var p = parseFloat(sessionStorage.getItem(POS));
      if (p > 0 && !audio.currentTime) audio.currentTime = p;
    } catch (e) {}
    var pr = audio.play();
    if (pr && pr.catch) pr.catch(function () { running = false; setUI(false); });
    fadeTo(VOLUME, 3000);
    try { sessionStorage.setItem(KEY, 'on'); } catch (e) {}
  }
  function stop() {
    running = false;
    setUI(false);
    fadeTo(0, 800, function () { if (!running) audio.pause(); });
    try { sessionStorage.setItem(KEY, 'off'); } catch (e) {}
  }
  btn.addEventListener('click', function (e) { e.stopPropagation(); running ? stop() : start(); });

  /* remember where the song was, so the next page continues from there */
  function savePos() { try { if (audio.currentTime) sessionStorage.setItem(POS, String(audio.currentTime)); } catch (e) {} }
  window.addEventListener('pagehide', savePos);
  setInterval(function () { if (running) savePos(); }, 2000);

  /* if it was playing on the previous page, resume on the visitor's first tap/click
     (browsers do not allow sound before an interaction) */
  var wasOn = false;
  try { wasOn = sessionStorage.getItem(KEY) === 'on'; } catch (e) {}
  if (wasOn) {
    var resume = function (e) {
      document.removeEventListener('pointerdown', resume, true);
      document.removeEventListener('keydown', resume, true);
      if (e && e.target && e.target.closest && e.target.closest('.alc-sound')) return;
      if (!running) start();
    };
    document.addEventListener('pointerdown', resume, true);
    document.addEventListener('keydown', resume, true);
  }
})();
